export default __webpack_public_path__ + "static/media/58.c0403a97.jpg";